<div class="card card-policy-address border rounded-3 border-0 shadow card-form-address">
    <div
        class="card-header bg-white border-bottom px=3 pt-3 pb-2 d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center">
        <h3 class="d-flex gap-3 align-items-center">
            <span class="title lh-sm fs-5 fw-semibold text-start d-flex flex-column">
                <span class="small">
                    Contacto y Dirección del Asegurado Principal
                </span>
            </span>
        </h3>
    </div>
    <div class="card-body p-3">
        <div class="d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-3" [formGroup]="form">
                <div class="text-uppercase text-secondary fw-semibold small">Datos de contacto</div>
                <div class="row g-2">
                    <div class="col-12">
                        <div class="form-floating">
                            <input type="email" class="form-control focus-ring focus-ring-light"
                                [class.is-invalid]="form.get('contactEmail')?.touched && form.get('contactEmail')?.invalid"
                                id="contactEmail" placeholder=" " formControlName="contactEmail">
                            <label for="contactEmail">Correo electrónico</label>
                            @if (form.get('contactEmail')?.hasError('required')) {
                            <div class="invalid-feedback">Requerido
                            </div>
                            }
                            @if (form.get('contactEmail')?.hasError('email')) {
                            <div class="invalid-feedback">Email inválido
                            </div>
                            }
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="tel" class="form-control focus-ring focus-ring-light"
                                [class.is-invalid]="form.get('homePhone')?.touched && form.get('homePhone')?.invalid"
                                id="homePhone" placeholder=" " formControlName="homePhone" mask="(000) 000-0000">
                            <label for="homePhone">Teléfono de casa</label>
                            <div class="invalid-feedback">Requerido</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="tel" class="form-control focus-ring focus-ring-light"
                                [class.is-invalid]="form.get('mobilePhone')?.touched && form.get('mobilePhone')?.invalid"
                                id="mobilePhone" placeholder=" " formControlName="mobilePhone" mask="(000) 000-0000">
                            <label for="mobilePhone">Número de celular</label>
                            <div class="invalid-feedback">Requerido</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column gap-3" [formGroup]="form">
                <div class="text-uppercase text-secondary fw-semibold small">Dirección de residencia</div>
                <div class="row g-2">
                    <div class="col-12">
                        <div class="form-floating">
                            <input type="text" class="form-control focus-ring focus-ring-light"
                                [class.is-invalid]="form.get('street')?.touched && form.get('street')?.invalid"
                                id="residentStreet" placeholder=" " formControlName="street" maxlength="150">
                            <label for="residentStreet">Calle y número</label>
                            <div class="invalid-feedback">Requerido</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <select class="form-select focus-ring focus-ring-light"
                                [class.is-invalid]="form.get('countryCode')?.touched && form.get('countryCode')?.invalid"
                                [class.bg-light]="form.get('countryCode')?.disabled" id="residentCountry"
                                formControlName="countryCode"
                                (change)="countryChange.emit(form.get('countryCode')?.value)">
                                <option [ngValue]="null" disabled selected>Seleccione</option>
                                @for (c of countries; track c?.countryCode) {
                                <option [ngValue]="c.countryCode">{{ c.countryName }}</option>
                                }
                            </select>
                            <label for="residentCountry">País</label>
                            <div class="invalid-feedback">Requerido</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-searchable-dropdown id="residentState" [items]="filteredStates" bindLabel="stateName"
                            bindValue="stateCode" [value]="form.get('stateCode')?.value"
                            [disabled]="!form.get('countryCode')?.value"
                            [invalid]="!!(form.get('stateCode')?.touched && form.get('stateCode')?.invalid)"
                            label="Estado / Provincia" placeholder="Buscar estado / provincia..."
                            (valueChange)="form.get('stateCode')?.setValue($event); stateChange.emit($event)"
                            (blurred)="form.get('stateCode')?.markAsTouched()">
                        </app-searchable-dropdown>
                        <div class="invalid-feedback d-block"
                            [class.d-none]="!(form.get('stateCode')?.touched && form.get('stateCode')?.invalid)">
                            Requerido
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <app-searchable-dropdown id="residentZipFullDesc" [items]="filteredZipFullDescs"
                            bindLabel="zipName" bindValue="zipCode" [value]="form.get('zipFullDescCode')?.value"
                            [disabled]="!form.get('stateCode')?.value"
                            [invalid]="!!(form.get('zipFullDescCode')?.touched && form.get('zipFullDescCode')?.invalid)"
                            placeholder="Buscar sector o paraje..." label="Sector o Paraje"
                            (valueChange)="form.get('zipFullDescCode')?.setValue($event)"
                            (blurred)="form.get('zipFullDescCode')?.markAsTouched()">
                        </app-searchable-dropdown>
                        <div class="invalid-feedback d-block"
                            [class.d-none]="!(form.get('zipFullDescCode')?.touched && form.get('zipFullDescCode')?.invalid)">
                            Requerido
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>